<div class="modal-wrapper">
    <div class="header">
        <img src="assets/svg/reusable-svg/warning.svg" alt="warning-icon" />
        <span>{{
            injectedData.internationalizationPrefix + '.header' | translate
        }}</span>
    </div>
    <div class="checks-wrapper tryb-new-design-scroll-bar">
        <div class="error-checks" *ngIf="errorChecks.length > 0">
            <span class="check-header">
                {{
                    injectedData.internationalizationPrefix +
                        '.checks.errorHeader' | translate
                }}
            </span>
            <span class="check-item" *ngFor="let errorCheck of errorChecks">
                {{
                    injectedData.internationalizationPrefix +
                        '.checks.errors.' +
                        errorCheck.name
                        | translate: getPlaceholderValues(errorCheck)
                }}
            </span>
        </div>
        <div class="hint-checks" *ngIf="hintChecks.length > 0">
            <span class="check-header">
                {{
                    injectedData.internationalizationPrefix +
                        '.checks.hintHeader' | translate
                }}
            </span>
            <span class="check-item" *ngFor="let hintCheck of hintChecks">
                {{
                    injectedData.internationalizationPrefix +
                        '.checks.hints.' +
                        hintCheck.name
                        | translate: getPlaceholderValues(hintCheck)
                }}
            </span>
        </div>
    </div>
    <div class="buttons-wrapper">
        <div class="without-errors" *ngIf="errorChecks.length < 1">
            <div class="button button-lila" (click)="onClose(false)">
                <span>{{
                    injectedData.internationalizationPrefix +
                        '.buttons.adjustData' | translate
                }}</span>
            </div>
            <div class="button button-red" (click)="onClose(true)">
                <span>{{
                    injectedData.internationalizationPrefix +
                        '.buttons.startNevertheless' | translate
                }}</span>
            </div>
        </div>
        <div class="with-errors" *ngIf="errorChecks.length > 0">
            <div class="button button-lila" (click)="onClose(false)">
                <span>{{
                    injectedData.internationalizationPrefix + '.buttons.ok'
                        | translate
                }}</span>
            </div>
        </div>
    </div>
</div>
